import { authClient, baseClient } from '@/utils'
import Config from '@/config'
import { getServiceURL } from '../utils/env.utils'


// @TODO: no auth needed
const fetchCatalogs = () => {
	return authClient.get(`${getServiceURL('products')}/v1/catalogs/get-min`)
}

const getDefaultCatalog = (ip) => {
	return baseClient.get(`${getServiceURL('masters')}/v1/common/default-values/by-ip/${ip}`, {
		params: {
			environment: Config.getInstance().getConfig('env'),
			site: 'private'
		}
	})
}

const getIpClient = () => {
	return baseClient.get(`https://where.vibia.com`)
}

export default {
	fetchCatalogs,
	getDefaultCatalog,
	getIpClient
}
